export const getNumberFormatter = (format, precesion) => {
  return (number) => {
    if (number) {
      return number.toLocaleString(format, {
        minimumFractionDigits: precesion != "undefined" ? precesion : 2,
        maximumFractionDigits: precesion != "undefined" ? precesion : 2,
      });
    } else {
      return "0";
    }
  };
};



// WEBPACK FOOTER //
// ./src/helper/currencyFormat.js